import { HandlingTypeEnum } from './enums/handling-type.enum';

export class HandlingType {
  public code!: string;
  public labelKey!: string;
  public labelKeyDimension?: string;
  public placeholderKeyDimension?: string;
  public icon!: string;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export const LIST_HANDLING_TYPE: { [key: string]: HandlingType } = {
  PALLET: new HandlingType({
    code: HandlingTypeEnum.PALLET,
    labelKey: 'LABEL.PALLETS',
    labelKeyDimension: 'LABEL.DIMENSIONS.PALLETS',
    placeholderKeyDimension: 'PLACEHOLDER.DIMENSIONS.PALLETS',
    icon: 'fas fa-pallet',
  }),
  PARCEL: new HandlingType({ code: HandlingTypeEnum.PARCEL, labelKey: 'LABEL.PARCELS', icon: 'fas fa-box' }),
  CRATE_OF_WINE: new HandlingType({
    code: HandlingTypeEnum.CRATE_OF_WINE,
    labelKey: 'LABEL.CRATE_OF_WINE',
    labelKeyDimension: 'LABEL.DIMENSIONS.CRATE_OF_WINE',
    placeholderKeyDimension: 'PLACEHOLDER.DIMENSIONS.CRATE_OF_WINE',
    icon: 'baryicon-crate_of_wine',
  }),
  BUNDLE: new HandlingType({ code: HandlingTypeEnum.BUNDLE, labelKey: 'LABEL.BUNDLE', icon: 'fas fa-xmarks-lines' }),
  CONTAINER: new HandlingType({
    code: HandlingTypeEnum.CONTAINER,
    labelKey: 'LABEL.CONTAINER',
    labelKeyDimension: 'LABEL.DIMENSIONS.CONTAINER',
    placeholderKeyDimension: 'PLACEHOLDER.DIMENSIONS.CONTAINER',
    icon: 'baryicon-surface-container',
  }),
  ROLL: new HandlingType({ code: HandlingTypeEnum.ROLL, labelKey: 'LABEL.ROLL', icon: 'fas fa-th-large' }),
  INDIVISIBLE: new HandlingType({ code: HandlingTypeEnum.INDIVISIBLE, labelKey: 'LABEL.INDIVISIBLE', icon: 'fas fa-tractor' }),
  PERSONALIZED: new HandlingType({ code: HandlingTypeEnum.PERSONALIZED, labelKey: 'LABEL.PERSONALIZED', icon: 'fas fa-expand-arrows-alt' }),
};
